import {formatCurrency} from "../../utils/helpers";
import React from "react";
import {TableCell, TableRow} from "@mui/material";

const TotalRecapRows = (props) => {
    const total = props.total
    const totalHT = total.totalHT;
    const totalTTC = total.totalTTC;
    const totalTVA = totalTTC - totalHT;
    const depositAmount = props.depositAmount ? props.depositAmount : (props.depositPercentage ? (props.depositPercentage / 100) * totalTTC : 0);


    return <React.Fragment>
        <TableRow>
            <TableCell sx={{border: 0}} colSpan={5}></TableCell>
        </TableRow>
        <TableRow>
            <TableCell sx={{border: 0}}></TableCell>
            <TableCell colSpan={3}>Total HT</TableCell>
            <TableCell align="right">{formatCurrency(totalHT)}</TableCell>
        </TableRow>
        <TableRow>
            <TableCell sx={{border: 0}}></TableCell>
            <TableCell colSpan={3}>Total TVA</TableCell>
            <TableCell align="right">{formatCurrency(totalTVA)}</TableCell>
        </TableRow>
        <TableRow>
            <TableCell sx={{border: 0}}></TableCell>
            <TableCell sx={{background: "#1e1e1e", color: 'white', fontWeight: 'bold'}} colSpan={3}>Total
                TTC</TableCell>
            <TableCell sx={{background: "#1e1e1e", color: 'white', fontWeight: 'bold'}}
                       align="right">{formatCurrency(totalTTC)}</TableCell>
        </TableRow>
        <TableRow>
            <TableCell sx={{border: 0}}></TableCell>
            <TableCell colSpan={3} sx={{pl: 4}}>Acompte</TableCell>
            <TableCell align="right">{formatCurrency(depositAmount)}</TableCell>
        </TableRow>
        <TableRow>
            <TableCell sx={{border: 0}}></TableCell>
            <TableCell colSpan={3} sx={{pl: 4}}>Solde</TableCell>
            <TableCell align="right">{formatCurrency(totalTTC - depositAmount)}</TableCell>
        </TableRow>
    </React.Fragment>
}

export default TotalRecapRows;